export enum PaymentMethod {
  TPAY = 'TPAY',
  CASH = 'CASH',
  TRANSFER = 'TRANSFER',
}
